import {
  DEFAULT_CURRENCY_CODE,
  type EnvironmentProviders,
  LOCALE_ID,
  type Provider,
} from '@angular/core';
import type { Route } from '@angular/router';
import {
  PreloadAllModules,
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withPreloading,
  withRouterConfig,
} from '@angular/router';
import {
  CUSTOM_DATE_FORMATS,
  CustomIconsService,
  GlobalErrorStateMatcher,
  customDateAdapter,
} from '..';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ErrorStateMatcher, MAT_DATE_FORMATS } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';

export function provideAppRouter(routes: Route[]): EnvironmentProviders {
  return provideRouter(
    routes,
    withComponentInputBinding(),
    withInMemoryScrolling({ scrollPositionRestoration: 'top' }),
    withPreloading(PreloadAllModules),
    // A guard that refuses Back or Forward then moves the browser back to where it was, instead of
    // overwriting the entry it went to.
    withRouterConfig({ canceledNavigationResolution: 'computed' })
  );
}

export const uiProvidersConfig: (Provider | EnvironmentProviders)[] = [
  { provide: LOCALE_ID, useValue: 'de-DE' },
  provideAnimations(),
  CustomIconsService,

  {
    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
    useValue: {
      appearance: 'outline',
      floatLabel: 'auto',
      subscriptSizing: 'dynamic', // for long error texts & better grid handling in forms
      color: 'primary',
    },
  },
  { provide: ErrorStateMatcher, useClass: GlobalErrorStateMatcher },
  { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
  customDateAdapter,
  { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
  {
    provide: MAT_DIALOG_DEFAULT_OPTIONS,
    useValue: {
      backdropClass: 'bg-cp-primary-80',
    },
  },
];
